import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IUser, IThreatAssessmentTeam } from '../models/contact';
import { ErrorService } from '../helpers/errorService';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  constructor(
    private http: HttpClient,
    private errorService: ErrorService
  ) { }

  getUsers(buildingId: string): Observable<IThreatAssessmentTeam[]> {
    const url = environment.apiBaseUrl + endpoints.users.replace(':buildingId', buildingId);
    return this.http.get<IThreatAssessmentTeam[]>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }

  getUserInfo(): Observable<IUser> {
    const url = environment.apiBaseUrl + endpoints.userInfo;
    return this.http.get<IUser>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }

  getThreatAssessmentTeam(caseId: string): Observable<any> {
    const url = environment.apiBaseUrl + endpoints.getThreatAssessmentTeam.replace(':caseId', caseId);
    return this.http.get<any>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }

  saveThreatAssessmentTeam(contactData: IThreatAssessmentTeam[]): Observable<any> {
    const url = environment.apiBaseUrl + endpoints.updateThreatAssessmentTeam;
    return this.http.post(url, contactData).pipe(
      catchError(this.errorService.handleSavingError)
    );
  }

  getUserPermissions(buildingId: string): Observable<{ canEdit: boolean; canAdmin: boolean }> {
    const url = `${environment.apiBaseUrl}${endpoints.getUserPermissions}?building_id=${buildingId}`;
    return this.http.get<{ canEdit: boolean; canAdmin: boolean }>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }

}